import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import unset from 'lodash/fp/unset';

const groupFields = ['firstTeam', 'secondTeam'];

const areEqual = (source, target) => {
  let changes = pick(source, groupFields);
  return isEqual(changes, pick(target, Object.keys(changes)));
};

export default (state = [], action = {}) => {
  switch (action.type) {
    case 'FORECAST_GROUPS_SET':
      return action.payload;
    case 'FORECAST_GROUPS_RESET_DIRTY':
      return state.map(unset('dirty'));
    case 'FORECAST_GROUPS_GROUP_SET': {
      let exists = state.some(m => m.group === action.meta.group);
      return exists
        ? state.map(
            match =>
              match.group === action.meta.group &&
              !areEqual(action.payload, match)
                ? { ...match, ...action.payload, dirty: true }
                : match
          )
        : [
            ...state,
            { group: action.meta.group, ...action.payload, dirty: true }
          ];
    }
    default:
      return state;
  }
};
